import { render, staticRenderFns } from "./select-field-empty.vue?vue&type=template&id=2b0bbae6&lang=pug"
import script from "./select-field-empty.vue?vue&type=script&lang=js"
export * from "./select-field-empty.vue?vue&type=script&lang=js"
import style0 from "./select-field-empty.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports